// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as LoadingRoutes from "../../app/Loading/LoadingRoutes.res.js";

let errorMessage = I18n.t("Wino could not generate the PDF, please reiterate your request.");

function endpoint(cashRegisterReportId, timeZone) {
  return Env.pdfUrl() + "/documents/cash-register-report/" + encodeURIComponent(cashRegisterReportId) + "?timeZone=" + encodeURIComponent(timeZone);
}

function urlFromResponse(response) {
  if (response.TAG !== "Ok") {
    return {
      TAG: "Error",
      _0: {
        TAG: "RequestError",
        _0: response._0
      }
    };
  }
  let url = Json.flatDecodeDictFieldString(Json.decodeDict(response._0), "url");
  if (url !== undefined) {
    return {
      TAG: "Ok",
      _0: url
    };
  } else {
    return {
      TAG: "Error",
      _0: "UnexpectedResponse"
    };
  }
}

function requestAndOpen(cashRegisterReportId, cashRegisterReportName) {
  let windowName = "cash-register-report-" + cashRegisterReportId;
  let windowUrl = LoadingRoutes.baseRoute(I18n.template(I18n.t("cash_register_report_pdf.generating"), {
    name: cashRegisterReportName
  }, undefined), undefined);
  let loadingWindow = window.open(windowUrl, windowName);
  if (loadingWindow == null) {
    return Future.value({
      TAG: "Error",
      _0: "OpenWindowError"
    });
  } else {
    return Future.tap(Future.map(Request.make(endpoint(cashRegisterReportId, I18n.timeZone), "GET", undefined, undefined, undefined), undefined, urlFromResponse), result => {
      if (result.TAG === "Ok") {
        loadingWindow.location = result._0;
        return;
      }
      loadingWindow.close();
    });
  }
}

export {
  errorMessage,
  endpoint,
  urlFromResponse,
  requestAndOpen,
}
/* errorMessage Not a pure module */
